// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PdpRespPrintHeader__wrap__f39c15d2","logo":"PdpRespPrintHeader__logo__f39c15d2","itemId":"PdpRespPrintHeader__itemId__f39c15d2"};